<div [formGroup]="zone2Form">
  <div class='container'>
    <div class="card">
      <div class="card-body">
        <h2 class="card-title btn-ouline-success-title">Zone n°2</h2>
        <div class="row">
          <div class='col-12'>
            <label class="form-label">Type de pose <span class="required">*</span></label>
            <div class="btn-group d-block" role="group">
              <ng-container *ngFor="let typePose of typePoses">
                <input type="radio" formControlName="typePoseZone2" class="btn-check btn-type-pose-options" [value]="typePose.code" [id]="typePose.code + 2"
                       (change)='onRadioClickZone2(typePose.code, "typePoseZone2")' tabindex="1">
                <label class="btn btn-outline-success btn-type-pose-options" [for]="typePose.code + 2"> {{ typePose.label }}</label>
              </ng-container>
            </div>
            <!--
            <select class="form-select" id="typePoseZone2" formControlName="typePoseZone2" tabindex="7">
              <option value=""></option>
              <option *ngFor="let typePose of typePoses" [ngValue]="typePose.code"
                      [selected]="zone2Form.get('typePoseZone2').value && typePose.code === zone2Form.get('typePoseZone2').value">
                {{ typePose.label }}
              </option>
            </select>
            -->
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone2Form.get('typePoseZone2').value === 'TOITURE'">
      <div class="card-body">
        <h2 class="card-title">Toiture</h2>
        <div class="row">
          <div class="col-5">
            <label class="form-label" for="typeToitureZone2">Type toiture <span class="required">*</span></label>
            <select class="form-select" id="typeToitureZone2" formControlName="typeToitureZone2" tabindex="10"
                    [ngClass]="zone2Form.get('typeToitureZone2').invalid && (zone2Form.get('typeToitureZone2').dirty || zone2Form.get('typeToitureZone2').touched) ? 'is-invalid' : ''">
              <option value=""></option>
              <option *ngFor="let typeToitureZone2 of typeToitures" [ngValue]="typeToitureZone2.code"
                      [selected]="zone2Form.get('typeToitureZone2').value && typeToitureZone2.code === zone2Form.get('typeToitureZone2').value">
                {{ typeToitureZone2.label }}
              </option>
            </select>
            <div class="invalid-feedback">
              <div *ngIf="zone2Form.get('typeToitureZone2').errors?.['required']">Le type de toiture est obligatoire</div>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group form-check">
              <span class="spanCheckbox">PV Ready <span class="required">*</span></span>
              <input class="form-check-input" type="checkbox" formControlName="pvReadyZone2" tabindex="11"
                     [ngClass]="zone2Form.get('pvReadyZone2').invalid && (zone2Form.get('pvReadyZone2').dirty || zone2Form.get('pvReadyZone2').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="zone2Form.get('pvReadyZone2').errors?.['required']">Cocher PV Ready</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <label for="inclinaisonZone2" class="form-label">Inclinaison <span class="required">*</span></label>
              <div class="col-10">
                <input type="number" class="form-control" id="inclinaisonZone2" formControlName="inclinaisonZone2" placeholder="Ex : 100" tabindex="12"
                       [ngClass]="zone2Form.get('inclinaisonZone2').invalid && (zone2Form.get('inclinaisonZone2').dirty || zone2Form.get('inclinaisonZone2').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone2Form.get('inclinaisonZone2').errors?.['pattern']">L'inclinaison n'est pas valide</div>
                  <div *ngIf="zone2Form.get('inclinaisonZone2').errors?.['required']">L'inclinaison est obligatoire</div>
                  <div *ngIf="zone2Form.get('inclinaisonZone2').errors?.['inclinaisonMax']">
                    L'inclinaison doit être comprise entre 0 et 3°
                  </div>

                  <div *ngIf="zone2Form.get('inclinaisonZone2').errors?.['inclinaisonMin']">
                    L'inclinaison doit être supérieure à 3°
                  </div>
                </div>
              </div>
              <div class="col-1">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="zone2Form.get('typeToitureZone2').value === 'BETON' || zone2Form.get('typeToitureZone2').value === 'TAN_ETANCHE'">
          <div class="col-12">
            <label class="form-label">Orientation</label>
            <div class="btn-group d-block" role="group">
              <input type="radio" formControlName="orientationTerrasseZone2" class="btn-check btn-type-pose-options" value="SUD" id="orientationSudZone2" tabindex="13">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationSudZone2">SUD</label>
              <input type="radio" formControlName="orientationTerrasseZone2" class="btn-check btn-type-pose-options" value="EST_OUEST" id="orientationEstOuestZone2" tabindex="14">
              <label class="btn btn-outline-success btn-type-pose-options" for="orientationEstOuestZone2">EST/OUEST</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="zone2Form.get('typePoseZone2').value === 'OMBRIERE'">
      <div class="card-body">
        <h2 class="card-title">Ombrière</h2>
        <div class="vehicule-options">
        <img
          src="../../../../assets/images/img/pl.png"
          alt="Poids Lourd"
          class="vehicule-img"
          [class.selected]="zone2Form.get('typeVehiculeParkingZone1')?.value === 'PL'"
          (click)="selectVehicule('PL', null)"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_1.png"
          alt="VL Place 1"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_1')"
          (click)="selectVehicule('VL', 'PLACE_1')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_2.png"
          alt="VL Place 2"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_2')"
          (click)="selectVehicule('VL', 'PLACE_2')"
        />
      
        <img
          src="../../../../assets/images/img/vl_portique.png"
          alt="VL Portique"
          class="vehicule-img"
          [class.selected]="isVLSelected('PORTIQUE')"
          (click)="selectVehicule('VL', 'PORTIQUE')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_1_bois.png"
          alt="VL Place 1 Bois"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_1_BOIS')"
          (click)="selectVehicule('VL', 'PLACE_1_BOIS')"
        />
      
        <img
          src="../../../../assets/images/img/vl_place_2_bois.png"
          alt="VL Place 2 Bois"
          class="vehicule-img"
          [class.selected]="isVLSelected('PLACE_2_BOIS')"
          (click)="selectVehicule('VL', 'PLACE_2_BOIS')"
        />
        
        <img
          src="../../../../assets/images/img/est_ouest.png"
          alt="VL Est Ouest"
          class="vehicule-img"
          [class.selected]="isVLSelected('EST_OUEST')"
          (click)="selectVehicule('VL', 'EST_OUEST')"
        />
      </div>
      <div
        class="error-message"
        *ngIf="
          zone2Form.get('typeVehiculeParkingZone2')?.invalid &&
          zone2Form.get('typeVehiculeParkingZone2')?.touched
        "
      >
        Le type de véhicule sur le parking est obligatoire
      </div>
      </div>
    </div>

    <div class="card" *ngIf="zone2Form.get('typePoseZone2').value">
      <div class="card-body">
        <div class="row">
          <div class='col-12'>
            <label for="surfaceZone2" class="form-label">Surface <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="surfaceZone2" formControlName="surfaceZone2" placeholder="Ex : 45.32" tabindex="8"
                 [attr.disabled]="true"
                 [ngClass]="zone2Form.get('surfaceZone2').invalid && (zone2Form.get('surfaceZone2').dirty || zone2Form.get('surfaceZone2').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone2Form.get('surfaceZone2').errors?.['required']">La surface est obligatoire</div>
                  <div *ngIf="zone2Form.get('surfaceZone2').errors?.['pattern']">La surface n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">m²</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="puissanceChoisieZone2" class="form-label">Puissance choisie</label>
            <div class="row">
              <div class="col-10">
                <input
                  type="number"
                  class="form-control"
                  id="puissanceChoisieZone2"
                  formControlName="puissanceChoisieZone2"
                  (focus)="onPuissanceChoisieFocus($event)"
                  [ngClass]="(zone2Form.get('puissanceChoisieZone2').invalid && (zone2Form.get('puissanceChoisieZone2').dirty || zone2Form.get('puissanceChoisieZone2').touched)) || (zone2Form.errors?.['surfaceOrPowerRequired'] && zone2Form.get('typePoseZone2').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone2Form.get('puissanceChoisieZone2').errors?.['pattern']">La puissance choisie n'est pas valide</div>
                  <div *ngIf="zone2Form.errors?.['surfaceOrPowerRequired']">La surface ou la puissance choisie est obligatoire</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">kWc</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class='col-12'>
            <label for="azimutZone2" class="form-label">{{ azimutLabel }} <span class="required">*</span></label>
            <div class="row">
              <div class="col-10">
                <input type="number" class="form-control" id="azimutZone2" formControlName="azimutZone2" placeholder="Ex : 100" tabindex="9"
                 [attr.disabled]="true"
                 [ngClass]="zone2Form.get('azimutZone2').invalid && (zone2Form.get('azimutZone2').dirty || zone2Form.get('azimutZone2').touched) ? 'is-invalid' : ''">
                <div class="invalid-feedback">
                  <div *ngIf="zone2Form.get('azimutZone2').errors?.['required']">L'azimut est obligatoire</div>
                  <div *ngIf="zone2Form.get('azimutZone2').errors?.['pattern']">L'azimut n'est pas valide</div>
                </div>
              </div>
              <div class="col-2">
                <span class="spanTextMiddle">°</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
